module.exports = __webpack_public_path__ + "assets/bazaarvoice-reviews.51fbcc79.svg";